import { createContext, useContext } from 'react'
import type { RecommendationCatalog } from '../domain/recommendation'
export type RecommendationAccess = {
  account: string
  catalog: RecommendationCatalog | null
  isCurrent: () => boolean
  ready: boolean
  busy: boolean
  requestOpen: () => void
  open: (id: string | null) => Promise<void>
}
export const RecommendationAccessContext = createContext<{
  access: RecommendationAccess | null
  setAccess: (value: RecommendationAccess | null) => void
}>({ access: null, setAccess: () => {} })
export const useRecommendationAccess = () =>
  useContext(RecommendationAccessContext)

/** Never expose another account's cached catalogue during a session transition. */
export function useCurrentRecommendationCatalog(account?: string) {
  const { access } = useRecommendationAccess()
  return access?.isCurrent() &&
    (account === undefined || access.account === account)
    ? access.catalog
    : null
}
